var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.18927L16.8107 2.99991C16.6714 2.86061 16.5061 2.75012 16.3241 2.67473C16.1421 2.59935 15.947 2.56055 15.75 2.56055C15.553 2.56055 15.358 2.59935 15.176 2.67473C14.994 2.75012 14.8287 2.86061 14.6894 2.99991L12.2198 5.46945L12.2197 5.46959L12.2195 5.46973L3.43941 14.2499C3.29967 14.3888 3.18888 14.5541 3.11345 14.7362C3.03803 14.9183 2.99947 15.1135 3.00001 15.3105V19.4999C3.00046 19.8976 3.15864 20.2789 3.43985 20.5601C3.72105 20.8413 4.10232 20.9995 4.50001 20.9999H8.68937C8.88643 21.0004 9.08164 20.9619 9.2637 20.8865C9.44576 20.8111 9.61105 20.7003 9.75001 20.5605L21.0001 9.31055C21.2809 9.02902 21.4387 8.64757 21.4386 8.2499C21.4386 7.85222 21.2809 7.47079 21 7.18927ZM18 10.1893L13.8107 5.99991L15.75 4.06055L19.9394 8.24991L18 10.1893Z",
    fill: "#FCC068"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.68ca9bf4b549078b9eee96839dea33ea.svg";
export { ForwardRef as ReactComponent };